import {
    Box,
    Button,
    Flex,
    Grid,
    Heading,
    Select,
    Text,
    useBreakpointValue,
    useColorModeValue
} from "@chakra-ui/react";
import { FiPlus as AddIcon } from "react-icons/fi";
import ProjectCard from "./ProjectCard";
import React, {useEffect, useState} from "react";
import NewProjectModal from "./NewProjectModal";

const Projects = ({ projects, setProjects, updateProjects }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [region, setRegion] = useState("all");

    const handleModalOpen = () => {
        setIsModalOpen(!isModalOpen);
    }

    const gridTemplateColumns = useBreakpointValue({
        base: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)",
        lg: "repeat(4, 1fr)",
        xl: "repeat(6,1fr)",
    });

    const handleRegionChange = (e) => {
        setRegion(e.target.value);
    }

    useEffect(() => {
        const refreshProjects = async () => {
            await new Promise(r => setTimeout(r, 1000));
            console.log("Projects are being refreshed");
            updateProjects();
        };

        refreshProjects();

    }, [isModalOpen])
    return (
        <Box>
            <NewProjectModal isModalOpen={isModalOpen} handleModalOpen={handleModalOpen} projects={projects} setProjects={setProjects}/>
            <Flex justifyContent="space-between" alignItems="center" mb={4}>
                <Heading size={{base: "md", md: "lg"}}>Existing Projects</Heading>

                <Box display={"flex"} gap={4}>
                    <Select w={"fit-content"} defaultValue={"all"} value={region} onChange={handleRegionChange}>
                        <option value={"all"}>All</option>
                        <option value={"north_america"}>North America</option>
                        <option value={"europe"}>Europe</option>
                        <option value={"asia"}>Asia</option>
                        <option value={"australia"}>Australia</option>
                    </Select>
                    <Button leftIcon={<AddIcon />} size={{base: "xs", md:"md"}} colorScheme="gray" variant="solid" onClick={handleModalOpen}>
                        Add Project
                    </Button>
                </Box>
            </Flex>
            <Grid templateColumns={"repeat(auto-fill, minmax(300px, 1fr))"} gap={6}>
                {projects.filter(project => region === 'all' ? true : project.region === region).map((project) => (
                    <ProjectCard key={project.id} project={project} />
                ))}

                {
                    projects.filter(project => region === 'all' ? true : project.region === region).length === 0
                    &&
                    <NoProjectsCard/>
                }
            </Grid>
        </Box>
    );
}

const NoProjectsCard = () => {
    return (
        <Flex p={4} bg={useColorModeValue("gray.50", "gray.700")} rounded={"md"}>
            <Text>No project found in the region</Text>
        </Flex>
    )
};

export default Projects;
